import * as Html from "../../util/Html.ts";
import * as modal from "../../util/modal.ts";
import * as amplify from "../../util/amplify.ts";
import ApiServer from "../../ApiServer.ts";
import * as actionMenu from "../action-menu-registry.ts"
import * as i18n from "../../i18n.ts"
import { TaskListCache } from "../../server/objects/TaskBeans.ts";
import { addSubmitHandler } from "../../util/forms.ts";

Html.registerWidget('widget/form/taskedit',{initDom})


actionMenu.register({
  tasklistselect(){
    var
      menu = this,
      input = menu.querySelector('input'),
      selectedId = input.value
    return {menu:TaskListCache.datas.map(list=>{return {
      svg:list.svg,
      iconclass:"color-branded",
      title:list.name,
      value:list.metaId,
      selected:selectedId===list.metaId,
      clickFunction(){
        input.value = (list.metaId)
        input.dispatchEvent(new Event('change'))
      }
    }})};
  }
})


function initDom(node: HTMLElement){
  const metaId = node.getAttribute('data-fw-meta-id');
  const form = node as HTMLFormElement;

  const dueDate = node.querySelector('input[name="dueDate"]') as HTMLInputElement;
  const textInput = node.querySelector('input[name="text"]') as HTMLInputElement;
  textInput.focus()
  
  function onDueDateChange(){
    const active = (dueDate.value !== '$empty');
    const reminderBlock = node.querySelector('.fw-reminder-block') as HTMLElement;

    if(reminderBlock){
      reminderBlock.style.display = active ? '' : 'none';
      if(!active){
        const reminderSelect = reminderBlock.querySelector('select') as HTMLSelectElement;
        if(reminderSelect){
          reminderSelect.value = '';
          reminderSelect.dispatchEvent(new Event('change'));
        }
      }
    }
  }

  const taskListIdSelect = node.querySelector("[name='taskListId']") as HTMLSelectElement;
  const taskCategorySelect = node.querySelector("[name='taskCategoryId']") as HTMLSelectElement;
  let taskCategoryId = taskCategorySelect.getAttribute("data-value");

  function handleTaskList(){
    const taskList = TaskListCache.get(taskListIdSelect.value);
    //use good category set
    if(taskCategorySelect.value){
      taskCategoryId = taskCategorySelect.value;
    }

    taskCategorySelect.innerHTML = '<option value="">🏷️ '+Html.escape(i18n.get('catsystem.uncategorized'))+'</option>'+taskList.getCategories(true).map(cat=>
      '<option value="'+cat.metaId+'" '+(taskCategoryId===cat.metaId?'selected':'')+'>'+Html.escape(cat.emoji+' '+cat.name)+'</option>'
    ).join('');

    //handle sharing of lits inside task
    if(taskList.sharedToAll){
      form.querySelectorAll<HTMLElement>('[data-accountid]').forEach(el=>el.style.display='')
    }else{
      form.querySelectorAll<HTMLElement>('[data-accountid]').forEach(el=>{
        const isSharedList = taskList.sharedMemberIds.indexOf(parseInt(el.getAttribute('data-accountid')))>-1
        el.style.display=isSharedList?'':'none'
        //we unclick those that are not sharable to
        if(!isSharedList && el.classList.contains('selected')){
          el.dispatchEvent(new Event("click"))
        }
      })
    }
  }

  taskListIdSelect.addEventListener('change', handleTaskList);
  dueDate.addEventListener('change', onDueDateChange);

  //we do it later to make sure it has been initialized
  setTimeout(function(){
    onDueDateChange();
    handleTaskList();
  },10);

  addSubmitHandler(form, async (form, event) => {
    if(metaId){
      await ApiServer.taskupdate2(form)
    }else{
      await ApiServer.taskcreate2(form)
    }
    modal.closeDomModal();
    amplify.publish('taskNeedRefresh');
    amplify.publish("activityUpdated");
  });
  
}